import dynamic from 'next/dynamic';
import { GuestRoomsProps } from './GuestRooms.types';

const GuestRoomsBau = dynamic<{ model: GuestRoomsProps }>(() => import('./GuestRooms').then(mod => mod.GuestRooms));

const GuestRoomsDtt = dynamic<{ model: GuestRoomsProps }>(() =>
  import('./GuestRoomsDtt').then(mod => mod.GuestRoomsDtt)
);

export const GuestRooms = (isDtt: boolean) => (isDtt ? GuestRoomsDtt : GuestRoomsBau);
